import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import request, { withRetry as retry } from '@flowio/request';
import config from './config';

function resetSession(sessionId, geo, _experiment, // keeping for legacy support.
attributes, organization, callback) {
  var form = {
    country: geo.country,
    currency: geo.currency,
    language: geo.language,
    experience: geo.experience,
    locale: geo.locale,
    attributes: attributes
  };
  retry(request.anonymous, {
    haltOnStatus: [404, 422]
  })({
    url: "".concat(config.API_BASE_URI, "/sessions/").concat(sessionId, "/organizations/").concat(organization),
    method: 'PUT',
    data: pickBy(form, identity),
    envelope: true
  }, callback);
}

export default resetSession;
//# sourceMappingURL=reset-session.js.map